// src/shared/supabase/functions/searchCars.ts
import supabase from "../../../shared/database/supabase";
import { CarRepository } from "../model/car";

export interface GetCarsByIdRequest {
  ids: string[];
}

export interface GetCarResponse {
  cars: CarRepository[];
  error?: { message: string } | string;
};

export const getCarsById = async (req: GetCarsByIdRequest) => {
  try {
    const { data, error } = await supabase.functions.invoke<GetCarResponse>("get-cars-by-id", {
      body: JSON.stringify({
        ids: req.ids,
      }),
    });

    const responseError = error || (data?.error
      ? new Error(typeof data.error === "string" ? data.error : data.error.message)
      : null);
    if (responseError) {
      console.error("Error calling get-cars-by-id:", responseError);
      return { cars: [], error: responseError };
    }
    if (!Array.isArray(data?.cars)) {
      return { cars: [], error: new Error("Resposta inválida ao carregar carro.") };
    }

    const cars = data?.cars.map((car: CarRepository) => ({
      id: car.id,
      plate: car.plate,
      brand: car.brand,
      model: car.model,
      color: car.color,
      insuranceName: car.insurance_name,
      chassisNumber: car.chassis_number,
      mileage: car.mileage ?? null,
      costumerId: car.costumer_id,
    })) || [];

    return {
      cars: cars,
      error: null
    };
  } catch (err) {
    console.error("Exception in getCarsById:", err);
    throw err;
  }
};
